/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import TableFilter from "../../table-components/filter/TableFilter";
import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useFetch from "../../../hooks/useFetch";
import TableComp from "../../table-components/table/TableComp";
import Pagination from "../../table-components/pagination/Pagination";
import AddModal from "../../modal/AddModal";
import AddUserLevel from "./AddUserLevel";
import { useDispatch, useSelector } from "react-redux";
import { handleEditOpen, rowValue } from "../../../redux/Reducer/ModalSlice";
import EditModal from "../../modal/EditModal";
import EditUserLevel from "./EditUserLevel";
import {
  ActiveStatus,
  InactiveStatus,
  StatusContainer,
} from "../../Dashboard/Dashboard.style";
import useProfile from "../../../hooks/useProfile";

const UserLevel = () => {
  const dispatch = useDispatch();
  const [userData] = useProfile();

  function handleEdit(rowData) {
    dispatch(handleEditOpen());
    dispatch(rowValue(rowData));
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "ug_level_id",
        Filter: false,
      },
      {
        Header: "User Level",
        accessor: "ugleve_name",
        Filter: false,
      },
      {
        Header: "Active Status",
        accessor: "active_fg",
        Filter: false,
        Cell: (e) => (
          <div
            style={{
              marginLeft: "10Px",
            }}
          >
            {e.value === "Y" ? (
              <StatusContainer>
                <ActiveStatus>Active</ActiveStatus>
              </StatusContainer>
            ) : (
              <StatusContainer>
                <InactiveStatus>Inactive</InactiveStatus>
              </StatusContainer>
            )}
          </div>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Action
          </div>
        ),
        accessor: "col3",
        Cell: (row) => (
          <ButtonGroup>
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#2196F3" }}
              // style={{}}
              variant="none"
              onClick={() => handleEdit(row.row.original)}
            >
              <Tooltip title="Update">
                <EditIcon sx={{ fontSize: 18 }} />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  const [user, isLoading, , refetch] = useFetch(
    `${process.env.REACT_APP_API_URL}/api/levelList/${userData?.id}`
  );

  const add = useSelector((state) => state.Modal.add);
  const edit = useSelector((state) => state.Modal.edit);

  useEffect(() => {
    if (!add) {
      refetch();
    }
  }, [add]);

  useEffect(() => {
    if (!edit) {
      refetch();
    }
  }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: user },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div>
        <TableFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          ButtonName="Add User Level"
        />
      </div>

      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "280px",
            }}
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      <AddModal ModalWidth="sm" ModalTitle="Add User Level">
        <AddUserLevel />
      </AddModal>

      <EditModal ModalWidth="sm" ModalTitle="Edit User Information">
        <EditUserLevel />
      </EditModal>
    </>
  );
};

export default UserLevel;
